module.exports = __webpack_public_path__ + "fox4.png";